export enum SortType {
  DESC = 'Newest',
  ASC = 'Oldest',
  LU = 'Last Updated',
}
